import { render, staticRenderFns } from "./AddInquiryModule.vue?vue&type=template&id=328ede84&"
import script from "./AddInquiryModule.vue?vue&type=script&lang=js&"
export * from "./AddInquiryModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports